import { humanReadableField } from '~/filters/humanReadableField';
import { ergonomicId, packagingId } from '~/helpers/fields-description';
import { LegrandModule } from './LegrandModule.model';

export class NLLV extends LegrandModule {
    isWired = true;

    get fieldErgonomics() {
        if (this.ergonomics) {
            return ergonomicId(humanReadableField(this.ergonomics) || 'Unknown');
        }
    }
    get fieldPackaging() {
        if (this.packaging) {
            return packagingId(humanReadableField(this.packaging));
        }
    }

}
